/** Multi-tile brushes: badge on thumbnails in the catalog. */
export const TILE_SET_DYNAMIC_BADGE = "Dynamic";

/** Copy for the Dynamic brush help tooltip (`DynamicBrushBadge`). */
export const TILE_SET_DYNAMIC_DESCRIPTION =
  "Each hex you paint picks one of several tiles at random for variety.";

/** Multi-decoration brushes: badge on thumbnails in the decoration catalog. */
export const DECORATION_SET_DYNAMIC_DESCRIPTION =
  "Each placement picks one of several decorations at random for variety.";

/** Ordered multi-tile brushes expose a persistent current tile. */
export const TILE_SET_ORDERED_BADGE = "Ordered";

/** Copy for the Ordered brush help tooltip. */
export const TILE_SET_ORDERED_DESCRIPTION =
  "Choose a specific tile in the set and cycle through the ordered variants with Q and E.";

/** Ordered multi-decoration brushes expose a persistent current decoration. */
export const DECORATION_SET_ORDERED_DESCRIPTION =
  "Choose a specific decoration in the set and cycle through the ordered variants with Q and E.";
